<template>
  <section class="not-found page-width">
    <span>404</span>
    <h1>页面不存在</h1>
    <p>链接可能已失效，或地址输入有误。你可以返回首页，或查看公开协议。</p>
    <div><a class="primary-action" href="/" data-route>返回首页</a><a class="text-action" href="/privacy/" data-route>查看隐私政策</a></div>
  </section>
</template>
